import { useCallback, useEffect, useRef, RefObject } from "react";

export const useInfiniteScroll = (
  callback: () => void
): RefObject<HTMLDivElement> => {
  const scrollableElRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(() => {
    const scrollableEl = scrollableElRef.current;

    if (scrollableEl) {
      const scrollableHeight = scrollableEl.scrollHeight;
      const scrolledFromTop =
        scrollableEl.clientHeight + scrollableEl.scrollTop;

      // If the user has scrolled to the bottom of the container, call the
      // callabck
      if (scrolledFromTop === scrollableHeight) {
        callback();
      }
    }
  }, [callback]);

  // Attach the scroll event listener to the scrollable div
  useEffect(() => {
    const scrollableEl = scrollableElRef.current;

    if (scrollableEl) {
      scrollableEl.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollableEl) {
        scrollableEl.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  return scrollableElRef;
};
